var map = {
	"./MOUTH1.svg": 4924,
	"./MOUTH10.svg": 46391,
	"./MOUTH11.svg": 22114,
	"./MOUTH12.svg": 43638,
	"./MOUTH2.svg": 87791,
	"./MOUTH3.svg": 28840,
	"./MOUTH4.svg": 47361,
	"./MOUTH5.svg": 57322,
	"./MOUTH6.svg": 83415,
	"./MOUTH7.svg": 33229,
	"./MOUTH8.svg": 39259,
	"./MOUTH9.svg": 23848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64652;